import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

// ✅ Menu structure supports nested subgroups
const menuGroups = [
  {
    parentLabel: "School",
    items: [
      // {
      //   parentLabel: "Medium & Board Management",
      //   items: [{ path: "/dashboard/board-medium", label: "Board & Medium" }],
      // },
      { path: "/dashboard/board", label: "Board" },
      {
        parentLabel: "Question Paper",
        items: [
          { path: "/dashboard/categories", label: "Question Types" },
          { path: "/dashboard/section", label: "Sections" },
          { path: "/dashboard/classes", label: "Manage Classes" },
          { path: "/dashboard/subjects", label: "Manage Subjects" },
          { path: "/dashboard/chapters", label: "Manage Chapters" },
          { path: "/dashboard/question-bank", label: "Question Bank" },
          { path: "/dashboard/answer-questions", label: "Create Paper" },
        ],
      },
      {
        parentLabel: "Sample Paper",
        items: [
          { path: "/dashboard/upload-sample-paper", label: "Upload Paper" },
          {
            path: "/dashboard/view-uploaded-sample-paper",
            label: "View Uploaded Sample Paper",
          },
        ],
      },
    ],
  },
  {
    parentLabel: "Quiz for law colleges",
    items: [
      {
        parentLabel: "Question Management",
        items: [
          {
            path: "/dashboard/college-quiz-questions",
            label: "Question Upload",
          },
          {
            path: "/dashboard/add-college-quiz-questions",
            label: "Manual Question Entry",
          },
          { path: "/dashboard/quiz-questions", label: "Quiz Questions" },
          { path: "/dashboard/laws", label: "Laws" },
        ],
      },
      {
        parentLabel: "Quiz Management",
        items: [
          {
            path: "/dashboard/create-quiz",
            label: "Add Quiz",
          },
          {
            path: "/dashboard/view-or-update-quizzes",
            label: "View / Update Quizzes",
          },
          { path: "/dashboard/user-management", label: "User Management" },
        ],
      },
    ],
  },
  {
    parentLabel: "School Quiz",

    items: [
      {
        parentLabel: "Quiz Question Management",
        items: [
          {
            path: "/dashboard/school-quiz-questions",
            label: "Question Upload",
          },
          {
            path: "/dashboard/add-school-quiz-questions",
            label: "Manual Question Entry",
          },
          {
            path: "/dashboard/get-school-quiz-questions",
            label: "Quiz Questions",
          },
          { path: "/dashboard/group", label: "Manage Groups / Classes" },
          { path: "/dashboard/themes", label: "Manage Themes / Subjects" },
          // { path: "/dashboard/classes", label: "Manage Classes" },
          // { path: "/dashboard/subjects", label: "Manage Subjects" },
        ],
      },
      {
        parentLabel: "Quiz Management",
        items: [
          {
            path: "/dashboard/create-school-quiz",
            label: "Add Quiz",
          },
          {
            path: "/dashboard/view-or-update-school-quizzes",
            label: "View / Update Quizzes",
          },
          {
            path: "/dashboard/school-user-management",
            label: "User Management",
          },
        ],
      },
    ],
  },
];

// 🔥 Recursive Menu Renderer
const MenuGroup = ({ group, openGroups, toggleGroup, location, level = 0 }) => {
  return (
    <li style={{ marginBottom: "8px" }}>
      {group.parentLabel ? (
        <div
          onClick={() => toggleGroup(group.parentLabel)}
          style={{
            cursor: "pointer",
            fontFamily: "Arial, sans-serif",
            fontWeight: "600",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 12px",
            borderRadius: "6px",
            backgroundColor: openGroups[group.parentLabel]
              ? "#34495e"
              : "transparent",
            transition: "background-color 0.2s",
            paddingLeft: `${12 + level * 10}px`, // indent nested groups
          }}
        >
          {group.parentLabel}
          <span>{openGroups[group.parentLabel] ? "▲" : "▼"}</span>
        </div>
      ) : null}

      {openGroups[group.parentLabel] && group.items && (
        <ul style={{ listStyle: "none", paddingLeft: "0", marginTop: "5px" }}>
          {group.items.map((item) =>
            item.items ? (
              <MenuGroup
                key={item.parentLabel}
                group={item}
                openGroups={openGroups}
                toggleGroup={toggleGroup}
                location={location}
                level={level + 1}
              />
            ) : (
              <li key={item.path}>
                <Link
                  to={item.path}
                  style={{
                    display: "block",
                    color:
                      location.pathname === item.path ? "#f1c40f" : "#ecf0f1",
                    textDecoration: "none",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    margin: "4px 0",
                    backgroundColor:
                      location.pathname === item.path
                        ? "#34495e"
                        : "transparent",
                    transition: "all 0.2s",
                    paddingLeft: `${20 + level * 10}px`,
                    fontWeight:
                      item.path === "/dashboard/board" ? "bold" : "500", // always bold for Board
                  }}
                >
                  {item.label}
                </Link>
              </li>
            ),
          )}
        </ul>
      )}
    </li>
  );
};

const Sidebar = () => {
  const location = useLocation();
  const [openGroups, setOpenGroups] = useState({});

  const toggleGroup = (label) => {
    setOpenGroups((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  return (
    <div
      style={{
        width: "300px",
        backgroundColor: "#2c3e50",
        color: "white",
        padding: "20px",
        minHeight: "100vh",
        borderRight: "1px solid #34495e",
      }}
    >
      <h2 style={{ color: "white", marginBottom: "20px" }}>Admin Panel</h2>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {menuGroups.map((group) => (
          <MenuGroup
            key={group.parentLabel}
            group={group}
            openGroups={openGroups}
            toggleGroup={toggleGroup}
            location={location}
          />
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
